import KidsNavBarContainer from 'components/KidsNavBar/KidsNavBarContainer'
import KidsNavBarPresentation from 'components/KidsNavBar/KidsNavBarPresentation'

export default {
  Container: KidsNavBarContainer,
  Presentation: KidsNavBarPresentation,
}
